import React from "react";
import "./privacyPolicy.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../components/appFooter";


export default function PrivacyPolicy(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>

                    </nav>
                </div>
            </div>

            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header">PRIVACY POLICY</h3>
                    </div>

                    <div className="col-lg-12">

                        <p><strong>About us</strong></p>
                        <p><Link to={"http://MemonId.com"}>MemonId.com</Link> (“<strong>MID</strong>”) is an online
                            portal
                            which provides an
                            interactive platform for the Memon community members across the globe to stay connected.</p>
                        <p>We provide an interactive portal for communication and facilitating information among the
                            members in regards to
                            education, helping professionals find career and business opportunities, matchmaking and
                            thus
                            enhancing
                            interaction among the members of the Memon community widely dispersed across the globe
                            (collectively the
                            “<strong>Services</strong>”).</p>
                        <p>When you use these Services, you’ll share some information with us. So we want to be upfront
                            about the
                            information we collect, how we use it, whom we share it with, and the choices we give you to
                            control, access,
                            and update your information.</p>
                        <p>We have written this Privacy Policy because it portrays why we’ve tried to write it in a way
                            that’s blissfully
                            free of the legalese that often clouds these documents. Of course, if you still have
                            questions about anything in
                            our Privacy Policy, just contact us.</p>
                        <p>This Privacy Policy shall apply uniformly to MID applications, desktop website &amp; mobile
                            WAP site (“<strong>Portal</strong>”).
                        </p>
                        <p><strong>Information we collect and retain</strong></p>
                        <p>For a better service the information we collect are categorized in three different
                            categories:</p>
                        <ol>
                            <li>Information you choose to give us.</li>
                        </ol>
                        <p>When you interact with our services, we collect the information that you choose to share with
                            us. For example,
                            most of our services require you to set up a basic account, so we need to collect a few
                            important details about
                            you, such as: Name, Phone Number, email address, State, City, Jamat you are registered with
                            we may also ask you
                            to provide us with some additional information like age, education, work experience, skills,
                            photo and other
                            details MID deems fit. Depending on your privacy settings other useful identifying
                            information will portrayed on
                            the Portal.</p>
                        <p>Kindly keep in mind that the other users of the Portal can always save the content or copy it
                            outside the
                            Portal which you have provided for a public view. So, the same common sense that applies to
                            the internet at
                            large applies to MID as well: Don’t send messages or share content that you wouldn’t want
                            someone to save or
                            share.</p>
                        <p>It probably goes without saying, but we will say it anyway: When you contact our Customer
                            Support or
                            communicate with us in any other way, we’ll collect whatever information you volunteer.</p>
                        <p>And we seek your personal information on MID when you make a donation, when you request a
                            communication from
                            us, register for an on-ground event, pledge support to our work and campaigns and apply for
                            working or
                            volunteering with MID. This information may be sought over the phone, through the website,
                            via email or by the
                            means of face-to-face interaction.</p>
                        <ol start="2">
                            <li>Information we get when you use our service.</li>
                        </ol>
                        <p>When you use our Services, we collect information about which of those services you’ve used
                            and how you’ve used
                            them. Here is a larger explanation of the types of information we collect when you use our
                            services:</p>
                        <ol>
                            <li>Posting and Uploading</li>
                        </ol>
                        <p>We collect personal data from you when you provide post or upload it to our Services, such as
                            when you fill out
                            a form, respond to a survey (e.g., members’ salary, certificates you upload, submit a resume
                            and apply for or
                            save jobs or send invitations or when you sign up for the matrimonial site).</p>
                        <ol start="2">
                            <li>Calendar and Email</li>
                        </ol>
                        <p>If you sync your email or calendars with our Services, we will collect your “email header”
                            and
                            calendar meeting
                            information (e.g. times, places, attendees).</p>
                        <ol start="3">
                            <li>Usage Information-</li>
                        </ol>
                        <p>How you communicate with other members of the Portal, such as their names, the time and date
                            of your
                            communications, the number of messages you exchange with other members, which members did
                            you
                            exchange messages
                            with the most, and your interactions with messages.</p>
                        <ol start="4">
                            <li>Device Information-</li>
                        </ol>
                        <p>We collect information from and about the devices you use. For example, we collect:</p>
                        <ul>
                            <li>
                                <p>Information about your hardware and software, such as the hardware model, operating
                                    system version, device
                                    memory, advertising identifiers, unique application identifiers, apps installed,
                                    unique device identifiers,
                                    browser type, language, battery level, and time zone;</p>
                            </li>
                            <li>
                                <p>Information from device sensors, such as accelerometers, gyroscopes, compasses,
                                    microphones, and whether
                                    you have headphones connected; and</p>
                            </li>
                            <li>
                                <p>Information about your wireless and mobile network connections, such as mobile phone
                                    number, service
                                    provider, and signal strength.</p>
                            </li>
                        </ul>
                        <ol start="5">
                            <li>Device Phonebook-</li>
                        </ol>
                        <p>Because MID is all about interaction, we may—with your consent—collect information from your
                            device’s
                            phonebook.</p>
                        <ol start="6">
                            <li>Camera and Photos-</li>
                        </ol>
                        <p>Many of our Services require us to collect images and other information from your device’s
                            camera and photos.
                            For example, you won’t be able to upload photos from your camera roll and scanned images of
                            your certificates to
                            MID unless we can access your camera or photos.</p>
                        <ol start="7">
                            <li>Location Information-</li>
                        </ol>
                        <p>When you use our Services we may collect information about your location. With your consent,
                            we may also
                            collect information about your precise location using methods that include GPS, wireless
                            networks, cell towers,
                            Wi-Fi access points, and other sensors, such as gyroscopes, accelerometers, and
                            compasses.</p>
                        <ol start="8">
                            <li>Information Collected by Cookies and Other Technologies-</li>
                        </ol>
                        <p>Like most online services and mobile applications, we may use cookies and other technologies,
                            such as web
                            beacons, web storage, and unique advertising identifiers, to collect information about your
                            activity, browser,
                            and device. We may also use these technologies to collect information when you interact with
                            Services we offer
                            through one of our partners, such as advertising and commerce features. Most web browsers
                            are
                            set to accept
                            cookies by default. If you prefer, you can usually remove or reject browser cookies through
                            the settings on your
                            browser or device. Keep in mind, though, that removing or rejecting cookies could affect the
                            availability and
                            functionality of our Services.</p>
                        <ol start="9">
                            <li>Log Information-</li>
                        </ol>
                        <p>We also collect log information when you use our Portal. That information includes, among
                            other things:</p>
                        <ul>
                            <li>
                                <p>Details about how you’ve used our Services.</p>
                            </li>
                            <li>
                                <p>Device information, such as your web browser type and language.</p>
                            </li>
                            <li>
                                <p>Access times.</p>
                            </li>
                            <li>
                                <p>Pages viewed.</p>
                            </li>
                            <li>
                                <p>IP address.</p>
                            </li>
                            <li>
                                <p>Identifiers associated with cookies or other technologies that may uniquely</p>
                            </li>
                            <li>
                                <p>Identify your device or browser.</p>
                            </li>
                            <li>
                                <p>Pages you visited before or after navigating to our website.</p>
                            </li>
                        </ul>
                        <ol start="3">
                            <li>Information from third parties.</li>
                        </ol>
                        <p>We may collect information that other users provide about you when they use our Services. For
                            example, if
                            another user allows us to collect information from their device phonebook—and you’re one of
                            that user’s
                            contacts—we may combine the information we collect from that user’s phonebook with other
                            information we have
                            collected about you. We may also obtain information from our Affiliates, or any other
                            third-party sources, and
                            combine that with the information we collect through our Services. For the purpose of this
                            Privacy Policy, the
                            term “<strong>Affiliates</strong>” shall include the local or regional Memon organizations /
                            associations /
                            jamats having arrangement with MID.</p>
                        <p>Credit/Debit Card Transactions, Electronic Fund Transfers and Payments by Cheque:</p>
                        <p>We avail the services of third parties to provide donation facilities by the means of cheque,
                            credit/debit card
                            payments or electronic fund transfers. While your information may be shared with these third
                            parties, we make
                            stringent efforts to require all third party service-providers to hold personal information
                            in strict
                            confidence. However, since we do not have complete control over these third parties, we
                            cannot guarantee your
                            privacy.</p>
                        <p><strong>How we use your information</strong></p>
                        <p>What do we do with the information we collect? The short answer is: Provide you with an
                            amazing set of services
                            that we relentlessly improve. Here are some of the ways we do that:</p>
                        <ol>
                            <li>
                                <p>Develop, operate, improve, deliver, maintain, and protect our products and
                                    services.</p>
                            </li>
                            <li>
                                <p>Send you communications, including by email. For example, we may use email to respond
                                    to support inquiries
                                    or to share information about our products, services, and promotional offers that we
                                    think may interest
                                    you.</p>
                            </li>
                            <li>
                                <p>Monitor and analyze trends and usage.</p>
                            </li>
                            <li>
                                <p>Personalize the Services by, among other things, suggesting profile information, or
                                    customizing the content
                                    we show you, including ads.</p>
                            </li>
                            <li>
                                <p>Provide and improve ad targeting and measurement, including through the use of your
                                    precise location data
                                    (again, if you’ve consented to us collecting that data), both on and off our
                                    Services. See the “<strong>Control
                                        over your information</strong>” section below for more information about MID
                                    advertising practices and
                                    your choices.</p>
                            </li>
                            <li>
                                <p>Enhance the safety and security of our services.</p>
                            </li>
                            <li>
                                <p>Verify your identity and prevent fraud or other unauthorized or illegal activity.</p>
                            </li>
                            <li>
                                <p>Use information we have collected from cookies and other technology to enhance the
                                    services and your
                                    experience with them.</p>
                            </li>
                            <li>
                                <p>Enforce our Terms of Service and other usage policies.</p>
                            </li>
                        </ol>
                        <p>We may also store some information locally on your device. For example, we may store
                            information as local cache
                            so that you can open the Portal and view content faster.</p>
                        <p><strong>How we share information</strong></p>
                        <p>We may share information about you in the following ways:</p>
                        <ol>
                            <li>With other members of MID.</li>
                        </ol>
                        <p>We may share the following information with other members of MID:</p>
                        <ul>
                            <li>
                                <p>Information about you, such as your username, name, profession, age, city and
                                    location
                                    and it will be set
                                    according to your privacy settings.</p>
                            </li>
                            <li>
                                <p>Information about how you have interacted with the Services, and other information
                                    that will help members
                                    of MID understand your connections with others using the Services.</p>
                            </li>
                            <li>
                                <p>Any additional information you have consented for us to share.</p>
                            </li>
                            <li>
                                <p>Content you send to us will be shared with other members of MID; how widely your
                                    content is shared depends
                                    on your personal settings and the type of service you are using. For example, if you
                                    have shared information
                                    about your profession with us it can be viewed by other members of the MID depending
                                    on the settings you
                                    have set for visibility.</p>
                            </li>
                        </ul>
                        <ol start="2">
                            <li>With all members of MID, our business partners, and the general public. We may share.
                            </li>
                        </ol>
                        <p>The following information with all members as well as with our business partners and the
                            general public:</p>
                        <ul>
                            <li>
                                <p>Public information like your name, username, profile code (if any) and profile
                                    pictures.</p>
                            </li>
                            <li>
                                <p>Information that will allow you to explore careers, evaluates educational
                                    opportunities, and seek out, and
                                    be found for, career opportunities. Your profile can be found by those looking to
                                    hire (for a job or a
                                    specific task) or be hired by you. We will use your data to recommend jobs, show you
                                    and others who work at
                                    a company, in an industry, function or location or have certain skills and
                                    connections. You can signal that
                                    you are interested in changing jobs and share information with job recruiters. We
                                    may
                                    use your profile and
                                    activity to recommend jobs to you and you to recruiters.</p>
                            </li>
                            <li>
                                <p>Information that will help you find the perfect match in our Matrimonial
                                    Services.</p>
                            </li>
                        </ul>
                        <ol start="3">
                            <li>With our Affiliates.</li>
                        </ol>
                        <p>We may share information with entities within the MID family of organizations and
                            Affiliates.</p>
                        <ol start="4">
                            <li>With third parties.</li>
                        </ol>
                        <p>We may share your information with the following third parties:</p>
                        <ul>
                            <li>
                                <p>With service providers, sellers, and partners. We may share information about you
                                    with
                                    service providers
                                    who perform services on our behalf, sellers that provide goods through our services,
                                    and business partners
                                    that provide services and functionality. For more information about data collected
                                    by
                                    third parties on our
                                    services.</p>
                            </li>
                            <li>
                                <p>With third parties for legal reasons. We may share information about you if we
                                    reasonably believe that
                                    disclosing the information is needed to: comply with any valid legal process,
                                    governmental request, or
                                    applicable law, rule, or regulation.</p>
                            </li>
                        </ul>
                        <ol>
                            <li>
                                <p>Investigate, remedy, or enforce potential Terms of Service violations.</p>
                            </li>
                            <li>
                                <p>Protect the rights, property, and safety of us, our users, or others.</p>
                            </li>
                            <li>
                                <p>Detect and resolve any fraud or security concerns.</p>
                            </li>
                        </ol>
                        <ul>
                            <li>
                                <p>With third parties as part of a merger or acquisition. MID gets involved in a merger,
                                    asset sale,
                                    financing, liquidation or bankruptcy, or acquisition of all or some portion of our
                                    business to body
                                    corporate; we may share your information with that body corporate before and after
                                    the transaction
                                    closes.</p>
                            </li>
                            <li>
                                <p>If MID is convinced that there has been some inappropriate activity with or on our
                                    Portal, communications,
                                    charitable services or personal or real property or if we have reasons to believe
                                    that anyone using one of
                                    the MID Portal, our donors, employees, partners, vendors, etc. have been inflicted
                                    with any harm, we will
                                    disclose (we may or may not notify you) personal information as we deem
                                    appropriate.</p>
                            </li>
                        </ul>
                        <p>We may also share with third parties—such as advertisers—aggregated, non-personally
                            identifiable, or
                            de-identified information.</p>
                        <p><strong>Third-party content and integrations</strong></p>
                        <p>The Services may also contain third-party links and search results, include third-party
                            integrations, or offer
                            a co-branded or third-party-branded service. Through these links, third-party integrations,
                            and co-branded or
                            third-party-branded services, you may be providing information (including personal
                            information) directly to the
                            third party, us, or both. You acknowledge and agree that we are not responsible for how
                            those
                            third parties
                            collect or use your information. As always, we encourage you to review the privacy policies
                            of every third-party
                            service that you visit or use, including those third parties you interact with through our
                            services. To learn
                            more about third-party services in MID, please contact our Customer Support.</p>
                        <p><strong>Analytics and advertising services</strong></p>
                        <ol>
                            <li>Provided by Others</li>
                        </ol>
                        <p>We may let other companies use cookies, web beacons, and similar technologies on our
                            services.
                            These companies
                            may collect information about how you use our services over time and combine it with similar
                            information from
                            other services and companies. This information may be used to, among other things, analyze
                            and track data,
                            determine the popularity of certain content, and better understand your online activity.</p>
                        <p>Additionally, some companies, including our Affiliates, may use information collected on our
                            Services to
                            measure the performance of ads and deliver more relevant ads on behalf of us or other
                            companies, including on
                            third-party websites and apps.</p>
                        <ol start="2">
                            <li>Provided by Us</li>
                        </ol>
                        <p>We may collect information about your activity on third-party services that use cookies and
                            other technologies
                            provided by us. We use this information to improve our advertising services, including
                            measuring the performance
                            of ads and showing you more relevant ads.</p>
                        <p><strong>Control over your information</strong></p>
                        <p>We want you to be in control of your information, so we provide you with the following
                            tools.</p>
                        <ol>
                            <li>Access and Updates-</li>
                        </ol>
                        <p>We strive to let you access and update most of the personal information that we have about
                            you. There are
                            limits though to the requests we will accommodate. We may reject a request for a number of
                            reasons, including,
                            for example, that the request risks the privacy of other users, requires technical efforts
                            that are
                            disproportionate to the request, is repetitive, or is unlawful. You can access and update
                            most of your basic
                            account information right in the Portal by visiting the Portal’s Settings page. If you need
                            to access, update,
                            or delete other personal information that we may have, you can put in a request here.
                            Because
                            your privacy is
                            important to us, we may ask you to verify your identity or provide additional information
                            before we let you
                            access or update your personal information. We will try to update and access your
                            information
                            for free, but if
                            it would require a disproportionate effort on our part, we may charge a fee. We will of
                            course disclose the fee
                            before we comply with your request.</p>
                        <ol start="2">
                            <li>Revoking Permissions-</li>
                        </ol>
                        <p>If you change your mind about our ongoing ability to collect information from certain sources
                            that you have
                            already consented to, such as your phonebook or location services, you can simply revoke
                            your
                            consent by
                            changing the settings on your device if your device offers those options. Of course, if you
                            do that, certain
                            services may lose full functionality.</p>
                        <ol start="3">
                            <li>Account Deletion-</li>
                        </ol>
                        <p>While we hope you’ll remain a lifelong MID member, if for some reason you ever want to delete
                            your account, you
                            go to the Portal settings. If you ask to delete your account, you will have up to 30 days to
                            restore your
                            account before we delete your information from our servers. During this period, your account
                            will not be visible
                            to other members of MID. And if for some reason we find that you have been providing wrong
                            information on MID,
                            or if you misbehave with any member on the Portal MID reserves the right to delete your
                            account.</p>
                        <ol start="4">
                            <li>Advertising Preferences-</li>
                        </ol>
                        <p>We try to show you ads that we think will be relevant to your interests. If you would like to
                            modify the
                            information we and our advertising partners use to select these ads, please contact the
                            Customer Support to
                            learn about the choices available to you.</p>
                        <ol start="5">
                            <li>Communicating with other members of MID-</li>
                        </ol>
                        <p>It’s also important to us that you stay in control over whom you communicate with. That’s why
                            we’ve built a
                            number of tools in Settings that let you indicate, among other things, who you want to
                            contact. Whether you’d
                            like to block another member from contacting you again. For more information about how to
                            control your privacy
                            settings contact the Customer Support.</p>
                        <p><strong>Children</strong></p>
                        <p>MID does not knowingly collect or solicit any information from anyone under the age of 13.
                            The
                            Service and its
                            content are not directed at children under the age of 13. In the event that we learn that we
                            have collected
                            personal information from a child under age 13 without parental consent, we will delete that
                            information as
                            quickly as possible. If you believe that we might have any information from or about a child
                            under 13, please
                            contact us.</p>
                        <p><strong>Revisions to the privacy policy</strong></p>
                        <p>We may change this Privacy Policy from time to time. But when we do, we’ll let you know one
                            way or another.
                            Sometimes, we’ll let you know by revising the date at the top of the Privacy Policy that’s
                            available on our
                            Portal. Other times, we may provide you with additional notice (such as adding a statement
                            to
                            our websites’
                            homepages or providing you with an in-app notification).</p>


                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>

    );
}
